import MainLayout from "Components/Layouts/MainLayout";
import NotifClientCard from "Components/Notifications/NotifClientCard";
import NotificationClient from "Components/Dashboard/NotificationClientDash";
import TodoClient from "Components/Todo/TodoClient";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllClients } from "../../redux/actions/ClientAction";
import InvoiceBanner from "Components/Dashboard/InvoicesBanner";
import SiteService from "Api/SiteService";
import { selectSites, setSites } from "state/site";
import ListSites from "Components/Dashboard/SitesStat/ListSites";
import MainHeader from "Components/Headers/MainHeader";
import ActiveClients from "Components/Dashboard/ActiveClients";
const { Box } = require("@mui/material");
const { LocalizationProvider, DateCalendar } = require("@mui/x-date-pickers");
const { AdapterDayjs } = require("@mui/x-date-pickers/AdapterDayjs");
const dayjs = require("dayjs");
const { useTheme } = require("@emotion/react");
function Home() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(new Date());
  // const client = useSelector((state) => state.client.client);
  // useEffect(() => {
  //     dispatch(getClient(id));
  // }, [dispatch, id]);
  // const invoices = useSelector((state) => selectInvoices(state));
  const sites = useSelector((state) => selectSites(state));

  useEffect(() => {
    const getSites = async () => {
      try {
        const data = await SiteService.getSitesDetails();
        dispatch(setSites({ sites: data }));
      } catch (error) {}
    };
    getSites();
  }, [dispatch]);
  // useEffect(() => {
  //     const getInvoices = async () => {
  //         try {
  //             //    setIsLoading(true);
  //             const data = await InvoiceService.getClientInvoicesDetails(
  //                 selectedDate
  //             );
  //             dispatch(setInvoices({ invoices: data }));
  //             //    setIsLoading(false);
  //         } catch (error) {
  //             //    setIsLoading(false);
  //             //    toast(`${error}`);
  //         }
  //     };
  //     getInvoices();
  // }, [selectedDate]);
  const clients = useSelector((state) => state.client.clients);
  useEffect(() => {
    dispatch(getAllClients());
  }, []);
  const notifCardInfo = [
    //   {
    //     id: 1,
    //     quantity: 5,
    //     image: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    //       <path d="M14.622 11.1493C14.5092 11.1493 14.434 11.1493 14.3964 11.1493C14.434 11.0744 14.4716 10.9995 14.5092 10.9247L16.4647 10.4754C16.6527 10.438 16.7656 10.2883 16.7656 10.1011V7.78009C16.7656 7.59291 16.6527 7.44317 16.4647 7.40573L14.4716 6.9565C14.3964 6.80676 14.3588 6.65702 14.2836 6.50728L15.3365 4.82268C15.4118 4.67293 15.4118 4.48575 15.2989 4.37345L13.6443 2.72628C13.5315 2.61398 13.3434 2.57654 13.193 2.68885L11.4632 3.73704C11.3127 3.66217 11.1623 3.62474 11.0119 3.54987L10.523 1.56578C10.4854 1.3786 10.335 1.2663 10.147 1.2663H7.81542C7.6274 1.2663 7.47697 1.3786 7.43937 1.56578L6.95049 3.54987C6.87528 3.5873 6.83768 3.5873 6.76247 3.62474C6.76247 3.54987 6.76247 3.47499 6.76247 3.43756C6.76247 2.5391 6.42402 1.67809 5.74711 1.00425C4.80697 0.0683565 3.49078 -0.231128 2.24979 0.180663C2.17458 0.218099 2.09937 0.330405 2.06176 0.442712C2.02416 0.555019 2.06176 0.704761 2.17458 0.779632L3.60359 2.23962L2.24979 3.5873L0.783173 2.16475C0.707962 2.05244 0.55754 2.01501 0.444723 2.05244C0.331906 2.08988 0.219089 2.16475 0.181484 2.27706C-0.232178 3.51243 0.0686668 4.86011 1.00881 5.796C1.6481 6.43241 2.51303 6.80676 3.45317 6.80676C3.52838 6.80676 3.60359 6.80676 3.6412 6.80676C3.60359 6.88163 3.56599 6.9565 3.52838 7.03137L1.57289 7.4806C1.38486 7.51804 1.27205 7.66778 1.27205 7.85496V10.176C1.27205 10.3631 1.38486 10.5129 1.57289 10.5503L3.56599 10.9995C3.60359 11.1493 3.67881 11.299 3.75402 11.4488L2.70106 13.1708C2.62585 13.3206 2.62585 13.5077 2.73867 13.62L4.39331 15.2672C4.50613 15.3795 4.69416 15.4169 4.84458 15.3046L6.57444 14.2564C6.72486 14.3313 6.87528 14.3687 7.02571 14.4436L7.47697 16.3903C7.51458 16.5774 7.665 16.6898 7.85303 16.6898H10.1846C10.3726 16.6898 10.523 16.5774 10.5606 16.3903L11.0495 14.4062C11.1247 14.3687 11.1623 14.3687 11.2375 14.3313C11.2375 14.4062 11.2375 14.4811 11.2375 14.5559C11.2375 15.4918 11.576 16.3528 12.2529 16.9892C12.8922 17.6256 13.7571 18 14.6596 18C15.0357 18 15.4118 17.9251 15.7878 17.8128C15.9006 17.7754 16.0134 17.6631 16.0511 17.5508C16.0887 17.4385 16.0511 17.2887 15.9382 17.2139L14.434 15.7164L15.7878 14.3687L17.2168 15.7913C17.292 15.8662 17.4425 15.9036 17.5553 15.9036C17.6681 15.8662 17.7809 15.7913 17.8185 15.6416C18.2322 14.4062 17.9313 13.0585 16.9912 12.16C16.3895 11.5236 15.5622 11.1493 14.622 11.1493ZM11.8392 9.20264L8.79317 6.17036C9.62049 6.09549 10.4102 6.39497 11.0119 6.99394C11.6136 7.59291 11.8768 8.37906 11.8392 9.20264ZM6.19838 8.75341L9.24444 11.7857C8.41711 11.8606 7.6274 11.5611 7.02571 10.9621C6.42402 10.3631 6.16078 9.57699 6.19838 8.75341ZM17.292 14.7805L16.0887 13.5826C15.9382 13.4329 15.7126 13.4329 15.5622 13.5826L13.6819 15.4544C13.5691 15.5293 13.5315 15.6416 13.5315 15.7164C13.5315 15.7913 13.5691 15.9036 13.6443 15.9785L14.8477 17.1764C14.058 17.2513 13.3058 16.9892 12.7418 16.3903C12.2529 15.9036 11.952 15.2298 11.952 14.4811C11.952 14.219 11.9896 13.9944 12.0649 13.7323C12.1025 13.5826 12.0649 13.4703 11.9896 13.358C8.26669 9.72674 6.12317 7.59291 4.54374 6.02061C4.43092 5.90831 4.3181 5.87087 4.16768 5.94574C3.94205 6.02061 3.67881 6.05805 3.41557 6.05805C2.70106 6.05805 2.02416 5.796 1.53529 5.2719C0.971202 4.71037 0.670357 3.92422 0.745568 3.17551L1.94895 4.37345C2.09937 4.52319 2.325 4.52319 2.47543 4.37345L4.35571 2.50167C4.46852 2.4268 4.50613 2.31449 4.50613 2.23962C4.50613 2.16475 4.46852 2.05244 4.39331 1.97757L3.18993 0.742197C3.97965 0.667326 4.73176 0.929375 5.29585 1.52834C5.82233 2.05244 6.08557 2.68885 6.08557 3.43756C6.08557 3.69961 6.04796 3.96166 5.97275 4.18627C5.93514 4.33601 5.97275 4.44832 6.08557 4.56063L13.5315 11.9729L13.5691 12.0103C13.7947 12.1975 14.0203 12.0477 14.2084 12.0103C15.0357 11.8606 15.9382 12.1226 16.5775 12.759C17.0664 13.2457 17.3672 14.0318 17.292 14.7805Z" fill="#1E5EFF" />
    //     </svg>
    //     ,
    //     text: "Matérielles actives"

    //   },
    // {
    //   id: 1,
    //   quantity: 5,
    //   image: (
    //     <svg
    //       width="20"
    //       height="16"
    //       viewBox="0 0 20 16"
    //       fill="none"
    //       xmlns="http://www.w3.org/2000/svg"
    //     >
    //       <path
    //         fill-rule="evenodd"
    //         clip-rule="evenodd"
    //         d="M18 0C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0H18ZM3.51862 2L10 7.671L16.4814 2H3.51862ZM18 3.32877L10 10.3288L2 3.32877V14H18V3.32877Z"
    //         fill="#1E5EFF"
    //       />
    //     </svg>
    //   ),
    //   text: "Mails en attente",
    // },
    {
      id: 1,
      quantity: sites.length,
      image: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.8708 6.75027L9.7842 0.747417C9.70837 0.52871 9.56855 0.339468 9.38391 0.205652C9.19928 0.0718353 8.97888 0 8.75294 0C8.527 0 8.3066 0.0718353 8.12196 0.205652C7.93733 0.339468 7.7975 0.52871 7.72167 0.747417L5.63507 6.75027H11.8708ZM14.6077 14.6251L13.0433 10.1252H4.46258L2.89817 14.6251H14.6077ZM1.08963 15.7501C0.799283 15.7501 0.520827 15.8686 0.31552 16.0796C0.110213 16.2905 -0.00512695 16.5767 -0.00512695 16.875C-0.00512695 17.1734 0.110213 17.4595 0.31552 17.6705C0.520827 17.8815 0.799283 18 1.08963 18H16.4162C16.7066 18 16.985 17.8815 17.1904 17.6705C17.3957 17.4595 17.511 17.1734 17.511 16.875C17.511 16.5767 17.3957 16.2905 17.1904 16.0796C16.985 15.8686 16.7066 15.7501 16.4162 15.7501H1.08963Z"
            fill="#1E5EFF"
          />
        </svg>
      ),
      text: "Chantier en cours",
    },

    {
      id: 2,
      quantity: clients.length,
      image: (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 9C12.3349 9 15.8645 12.4478 15.9962 16.7508L16 17V18H0V17C0 12.5817 3.58172 9 8 9ZM8 11C5.14444 11 2.75479 12.9948 2.14861 15.667L2.10104 15.8977L2.084 16H13.915L13.899 15.8977C13.4095 13.2618 11.1969 11.2312 8.47386 11.0184L8.22494 11.0041L8 11ZM8 0C10.2091 0 12 1.79086 12 4C12 6.20914 10.2091 8 8 8C5.79086 8 4 6.20914 4 4C4 1.79086 5.79086 0 8 0ZM8 2C6.89543 2 6 2.89543 6 4C6 5.10457 6.89543 6 8 6C9.10457 6 10 5.10457 10 4C10 2.89543 9.10457 2 8 2Z"
            fill="#1E5EFF"
          />
        </svg>
      ),
      text: "Client actifs",
    },
  ];
  return (
    <>
      <MainHeader />
      <MainLayout>
        <div className="container">
          <div
            className="row"
            style={{ padding: "calc(var(--bs-gutter-x) * .5)" }}
          >
            <InvoiceBanner
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              darkMode
            />
          </div>
          <div className="row">
            {notifCardInfo.map((notif) => (
              <div className="col-md-6" key={notif.id}>
                <NotifClientCard key={notif.id} notif={notif} fullWidth />
              </div>
            ))}
          </div>

          <div
            className="row mb-3"
            style={{ marginTop: "calc(var(--bs-gutter-x) * .5)" }}
          >
            <div className="col-md-4">
              <div className="card  d-flex justify-content-center">
                <Box
                  sx={{
                    "& .MuiIconButton-root": {
                      color: theme.palette.secondary.main,
                      bgcolor: theme.palette.primary.main,
                      borderRadius: "4px",
                      ml: "4px",
                    },
                    "& .MuiPickersCalendarHeader-label": {
                      color: theme.palette.secondary.main,
                      fontSize: "16px",
                      fontWeight: "bold",
                    },
                    "& .MuiButtonBase-root": {
                      color: theme.palette.secondary.main,
                      fontSize: "14px",
                    },
                    "& .MuiButtonBase-root.Mui-selected": {
                      color: theme.palette.secondary.main,
                      bgcolor: theme.palette.alt.main,
                      fontSize: "16px",
                      borderRadius: "4px",
                    },
                    "& .MuiButtonBase-root.Mui-selected:hover": {
                      bgcolor: theme.palette.alt.main,
                    },
                    "& .css-1acgcob-MuiButtonBase-root-MuiPickersDay-root.Mui-selected":
                      {
                        bgcolor: theme.palette.alt.main,
                      },
                    "& .css-1acgcob-MuiButtonBase-root-MuiPickersDay-root:focus ":
                      {
                        bgcolor: theme.palette.alt.main,
                      },
                    "& .css-1acgcob-MuiButtonBase-root-MuiPickersDay-root:focus.Mui-selected":
                      {
                        bgcolor: theme.palette.alt.main,
                      },
                    "& .MuiDayCalendar-weekDayLabel": {
                      color: theme.palette.grey[400],
                      fontSize: "14px",
                    },
                    "& .MuiPickersYear-root": {
                      color: theme.palette.secondary.main,
                    },
                    "& .MuiPickersYear-yearButton": {
                      fontSize: "16px",
                    },
                    "& .css-9yhg0o-MuiPickersYear-yearButton.Mui-selected": {
                      bgcolor: theme.palette.alt.main,
                    },
                  }}
                >
                  {/* <Calendar value={date} onChange={(e) => setDate(e.value)} inline showWeek /> */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      sx={{
                        bgcolor: theme.palette.grey[100],
                        height: "100%",
                      }}
                      onChange={(value) => setSelectedDate(new Date(value))}
                      defaultValue={dayjs(new Date())}
                      value={dayjs(selectedDate)}
                    />
                  </LocalizationProvider>
                </Box>
              </div>
              <div className="flex justify-content-center">
                <TodoClient selectedDate={selectedDate} />
              </div>
            </div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex justify-content-center">
                    <NotificationClient selectedDate={selectedDate} />
                  </div>
                </div>
                <div className="col-md-6">
                  <ActiveClients />
                </div>
              </div>
              <ListSites />
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
}

export default Home;
